import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const totalBedroomsTagManager = createRangeTagManager({
  jsonQueryKey: 'bedroom_total',
  template: 'Спален в доме %s',
  id: 'totalBedrooms',
});
